import React from 'react';
import { MuiTypography } from 'theme/material-ui';
import { Color } from 'modules/styles/colors';
import {
  splitTextIntoLinesArray,
  linkRegex,
  parseLineIntoTextPartsObject,
  ensureProtocol
} from 'lib/messaging/rtf/parseHyperlink';
import { MessageDetail } from 'store/messaging/types';

export const generateMessageTextComponents = (text: string) => {
  const lines = splitTextIntoLinesArray(text);
  return lines?.map((line: string) => {
    if (linkRegex.test(line)) {
      const lineParts = parseLineIntoTextPartsObject(line);
      const components = lineParts?.map(({ link, before, after }) => {
        return generateLinkComponent(link, before, after);
      });
      return components;
    }
    return <MuiTypography key={Math.random()}>{line}</MuiTypography>;
  });
};

export const generateLinkComponent = (link: string, before?: string, after?: string) => {
  const url = ensureProtocol(link);
  return (
    <MuiTypography key={link} display="inline">
      {before}
      <MuiTypography color={Color.link} sx={{ textDecoration: 'underline' }} display="inline">
        <a target="_blank" rel="noopener noreferrer" href={url}>
          {link}
        </a>
      </MuiTypography>
      {after}
    </MuiTypography>
  );
};

// Try using plaintext -> fallback to text -> fallback to No Content
export const getMessageText = (message: MessageDetail, shouldUseRTFConversion: boolean) => {
  if (shouldUseRTFConversion) {
    if (message?.texts?.length) {
      const messageText: string[] = message.texts.map(item => {
        const text = item.plainText || item.text || '(No Content)';
        if (!shouldUseRTFConversion) return text;

        return item.formatType === 'RTF' && shouldUseRTFConversion ? (
          generateMessageTextComponents(item.plainText)
        ) : (
          <MuiTypography>{text}</MuiTypography>
        );
      });
      return messageText;
    }
    return <MuiTypography>(No Content)</MuiTypography>;
  }
  if (message?.texts?.length) {
    const messageText: string[] = message.texts.map(
      item => item.plainText || item.text || '(No Content)'
    );
    return messageText;
  }
  return '(No Content)';
};

export default getMessageText;
